import * as React from 'react';
import { Link } from 'react-router-dom';
import { LinkContextProvider } from 'app/components/contexts/link-context';

export function withLink<P>(WrappedComponent: React.ComponentClass<P> | React.FC<React.PropsWithChildren<P>>) {
    return (props) => (
      props.url ?
          <Link to={props.url}>
            <LinkContextProvider value={true}>
              <WrappedComponent {...props}/>
            </LinkContextProvider>
          </Link>
          :  <WrappedComponent {...props} />
    );
  }
